import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import HeroSection from "../../components/website/sections/HeroSection";
import TestimonialsSection from "../../components/website/sections/TestimonialsSection";
import AboutOverviewSection from "../../components/website/sections/AboutOverviewSection";
import ServicesSection from "../../components/website/sections/ServicesSection";
import FeaturedProjectsSection from "../../components/website/sections/FeaturedProjectsSection";
import RequestForm from "../../components/website/forms/RequestForm";
import LeadersVoiceSection from "../../components/website/sections/LeadersVoiceSection";
import BrandsSection from "../../components/website/sections/BrandsSection";

const Home: React.FC = () => {
  return (
    <main>
      <HeroSection />
      <ServicesSection />
      <AboutOverviewSection />
      <LeadersVoiceSection />
      <FeaturedProjectsSection />
      <BrandsSection />
      <TestimonialsSection />
      <section className='brand-cta-section text-center py-5'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-8 mb-4'>
              <h4 className='mb-3 website-section-title text-white'>
                Build with a team focused on quality, timelines, and clear
                communication.
              </h4>
              <p className='lead mb-4'>
                Whether you are planning a new home, a commercial space, a site
                upgrade, or repair work, our team is ready with clear guidance
                and dependable execution.
              </p>
              <div className='brand-cta-contact'>
                <div className='brand-cta-contact-copy'>
                  <span className='brand-cta-contact-label'>Call Us</span>
                  <h6 className='mb-1'>Speak with our project support team</h6>
                  <p className='mb-0'>
                    Contact us for planning advice, scope discussion, and the
                    next practical step for your project.
                  </p>
                </div>
                <a
                  href='tel:+918182833009'
                  className='btn btn-light brand-cta-contact-btn'
                >
                  <i className='bi bi-telephone-fill me-2'></i>
                  +91 81828 33009
                </a>
              </div>
              <div className='row g-3 brand-cta-metrics mt-4'>
                <div className='col-6 col-xl-3'>
                  <div className='brand-cta-metric-card'>
                    <strong>500+</strong>
                    <span>Projects Delivered</span>
                  </div>
                </div>
                <div className='col-6 col-xl-3'>
                  <div className='brand-cta-metric-card'>
                    <strong>20+</strong>
                    <span>Years Of Experience</span>
                  </div>
                </div>
                <div className='col-6 col-xl-3'>
                  <div className='brand-cta-metric-card'>
                    <strong>Fast</strong>
                    <span>Response And Follow-Up</span>
                  </div>
                </div>
                <div className='col-6 col-xl-3'>
                  <div className='brand-cta-metric-card'>
                    <strong>98%</strong>
                    <span>Client Satisfaction</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-4'>
              <RequestForm />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
